import { CUSTOM_FIELDS_TYPES } from 'Dictionaries/customFields/customFieldsEnums';

const getCustomFieldsByGroup = (customFields) => {
    const groupedCustomFields = [];
    if (!customFields) {
        return groupedCustomFields;
    }
    for (const customField of customFields) {
        const groupIndex = groupedCustomFields.findIndex(
            (group) => group.id === customField.customfield_group.id,
        );

        if (groupIndex === -1) {
            groupedCustomFields.push({
                id: customField.customfield_group.id,
                name: customField.customfield_group.name,
                openByDefault: customField.customfield_group.open_by_default,
                customFields: [{ ...customField }],
            });
            continue;
        }

        if (customField.customfield_group.id === groupedCustomFields[groupIndex].id) {
            groupedCustomFields[groupIndex].customFields.push(customField);
        }
    }
    return groupedCustomFields.sort((a, b) => a.id - b.id);
};

export const getUngroupedCustomFields = (customFields) => {
    const group = getCustomFieldsByGroup(customFields).find((group) => group.id === 0);
    if (!group) {
        return null;
    }
    return {
        ...group,
        customFields: group.customFields.sort((a, b) => a.rank - b.rank),
    };
};

export const getFilteredCustomFields = (customFields) => {
    const filteredGroupedCustomFields = getCustomFieldsByGroup(customFields).filter(
        (group) => group.id !== 0,
    );
    return filteredGroupedCustomFields.map((group) => {
        return {
            ...group,
            customFields: group.customFields.sort((a, b) => a.rank - b.rank),
        };
    });
};

export const initCfWithDefaultValues = (customFields) => {
    for (const cf of customFields) {
        cf.error = null;
        switch (cf.type) {
            case CUSTOM_FIELDS_TYPES.NUMERIC_WITH_UNIT:
                cf.value = {
                    number: cf.parameters.default_value ?? null,
                    unit_id: null,
                };
                break;
            case CUSTOM_FIELDS_TYPES.RICH_TEXT:
            case CUSTOM_FIELDS_TYPES.SIMPLE_TEXT:
            case CUSTOM_FIELDS_TYPES.EMAIL:
            case CUSTOM_FIELDS_TYPES.URL:
            case CUSTOM_FIELDS_TYPES.BOOLEAN:
            case CUSTOM_FIELDS_TYPES.NUMERIC:
                cf.value = cf.parameters.default_value ?? null;
                break;
            case CUSTOM_FIELDS_TYPES.AMOUNT:
                cf.value = {
                    amount: cf.parameters.default_value ?? null,
                    currency: cf.parameters.currency ?? null,
                };
                break;
            case CUSTOM_FIELDS_TYPES.CHECKBOX:
                cf.value = cf.parameters.items
                    .filter((item) => item.checked)
                    .map((item) => item.id);
                break;
            case CUSTOM_FIELDS_TYPES.RADIO:
            case CUSTOM_FIELDS_TYPES.SELECT:
                cf.value = cf.parameters.items.find((item) => item.checked)?.id ?? null;
                break;
            default:
                cf.value = null;
                break;
        }
    }
};

export const formatCustomFieldsPayload = (customFields) => {
    const customFieldsFormatted = JSON.parse(JSON.stringify(customFields));
    return customFieldsFormatted.map((customField) => {
        if (customField.value) {
            if (customField.type === CUSTOM_FIELDS_TYPES.TIME) {
                const amPmRegex = /[ap]m$/i;
                if (amPmRegex.test(customField.value)) {
                    customField = {
                        ...customField,
                        value: moment(customField.value, 'hh:mm A').format('HH:mm'),
                    };
                }
            }
        }
        return {
            id: customField.id,
            value: customField.value,
        };
    });
};
